export default "__VITE_ASSET__Jqj7XGUO__"